


export function getColorBasedOnStatut(idStatut) {
    
    if (idStatut == 0) {
        return "#1CC88A"
    } else if (idStatut == 1) {
        return "#F6C23E"
    } else if (idStatut == 2 || idStatut == 3){
        return "#e74a3b"
    } else {
        return "";
    }
}